<script setup lang="ts">
import LoadingSpinner from '@webapp2/shared/components/icons/LoadingSpinner.vue'
import { computed, defineAsyncComponent, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { isNavigating } from './router'
import { state } from './state'

const router = useRouter()
const route = useRoute()
const loading = ref(true)

const AuthLayout = defineAsyncComponent(() => import('./auth/Layout.vue'))
const AppLayout = defineAsyncComponent(() => import('./layout/AppLayout.vue'))

const isAuth = computed(() => route.meta.layout === 'auth')
const layout = computed(() => (isAuth.value ? AuthLayout : AppLayout))
const showLoading = computed(() => loading.value || (isAuth.value && isNavigating.value))
const vuplexStyle = computed(() => state.vuplex && route.meta.layout !== 'admin')

onMounted(async () => {
  await router.isReady()
  loading.value = false
  blockExternalLinksOnDevice()
})

watch(vuplexStyle, x => document.documentElement.classList.toggle('vuplex', x))

function blockExternalLinksOnDevice() {
  if (state.platform === 'web') {
    return
  }

  document.addEventListener('click', e => {
    const href = (e.target as HTMLElement)?.closest('a')?.getAttribute('href')
    if (!href) {
      return
    }
    const isExternal = href.startsWith('http://') || href.startsWith('https://')
    if (isExternal) {
      e.preventDefault()
      e.stopPropagation()
    }
  })
}
</script>

<template>
  <div v-if="showLoading" class="flex h-screen items-center justify-center">
    <LoadingSpinner class="h-96 w-96" />
  </div>
  <template v-else>
    <component :is="layout">
      <RouterView />
    </component>
  </template>
</template>
